import React from 'react';

const StickyNavFix = () => {
    return (
        <style>{`
            /* FORCE FIXED NAVBARS ON MOBILE (not sticky - fixed!) */
            @media (max-width: 1199px) {
                .mobile-navbar-wrapper {
                    position: fixed !important;
                    top: 10px !important;
                    left: 0 !important;
                    right: 0 !important;
                    z-index: 1001 !important;
                    background: white !important;
                    width: 100% !important;
                }

                .horizontal-scroll-nav,
                .headerNavSpacing {
                    position: fixed !important;
                    top: 80px !important;
                    left: 0 !important;
                    right: 0 !important;
                    z-index: 1000 !important;
                    background: white !important;
                    width: 100% !important;
                    margin: 0 !important;
                }

                /* Make the navbar fill full width */
                .horizontal-scroll-nav .container-fluid {
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                    max-width: 100% !important;
                }

                /* Add padding to body content - reduced from 180px */
                body {
                    padding-top: 0 !important;
                }

                /* Only add padding to main on pages that need it */
                main {
                    padding-top: 0 !important;
                }

                /* Add padding to first element after navbars */
                .btn-light.my-3 {
                    margin-top: 100px !important;
                }

                .container > .section-header,
                .hero-carousel-section {
                    margin-top: 160px !important;
                }
            }
        `}</style>
    );
};

export default StickyNavFix;
